<template>
  <div ref="top">
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <validation-observer ref="articleForm">
        <b-form class="articleForm" @submit.prevent="" @reset.prevent="resetForm">
          <div class="d-flex  flex-column divArea">
            <div class="frmContent">
              <div class="divContent">
                <div class="card mb-xs-1">
                  <div ref="errorP" class="card-body p-1">
                    <b-row>
                      <b-col cols="12">
                        <validation-provider #default="validationContext" vid="title" name="Tiêu đề" mode="eager"
                          rules="required|max:255">
                          <b-form-group>
                            <template #label>
                              <div class="d-flex flex-row justify-content-between">
                                <label class="d-block font-weight-bolder  ">Tiêu đề <span
                                    class="text-danger">*</span></label>
                                <b-form-checkbox v-model="frmData.hot" value="1" class="checkboxLabel"> Tin nóng
                                </b-form-checkbox>
                              </div>
                            </template>
                            <b-form-input id="title" ref="title" v-model="frmData.title" autofocus
                              :state="getValidationState(validationContext)" placeholder="Tiêu đề bài viết" />
                            <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <validation-provider #default="validationContext" name="Chuyên mục" vid="category_id"
                          rules="required">
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Chuyên mục <span
                                  class="text-danger">*</span></label>
                            </template>
                            <v-select ref="category_id" v-model="frmData.category_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="all_cats"
                              :reduce="(val) => val.code" :state="getValidationState(validationContext)"
                              placeholder="--Chọn--" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{
                              validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Đăng thêm vào mục </label>
                          </template>
                          <v-select v-model="frmData.main_cats" multiple class="maincats" :options="data_cats"
                            :reduce="(val) => val.code" placeholder="--Chọn--" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <validation-provider #default="validationContext" name="Thể loại" vid="article_type_id"
                          rules="required">
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Thể loại <span
                                  class="text-danger">*</span></label>
                            </template>
                            <v-select v-model="frmData.article_type_id"
                              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="dataArticleType" label="name"
                              :reduce="(val) => val.id" :state="getValidationState(validationContext)"
                              placeholder="--Chọn--" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{
                              validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Nhờ xử lý" label-for="v-handler">
                          <v-select v-model="frmData.department_id" :options="dataDepartment" :disabled="show_nhoxuly"
                            label="name" :reduce="val => val.id" placeholder="--Chọn--" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Đồng tác giả" class="author" label-for="author">
                          <v-select v-model="frmData.author" multiple label="username" :filterable="false"
                            :options="dataAuthor" :reduce="val => val.id" @option:selecting="selectedOption"
                            @option:deselected="deselectedOption" @search="onSearch">
                            <template slot="no-options"> Nhập tên tài khoản </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center"> {{ option.full_name_alias }} </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center"> {{ option.full_name_alias }} </div>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group v-slot="{ ariaDescribedby }" label="Loại tin bài" class="content_type mb-0">
                          <b-form-checkbox v-for="option in dataContentType" :key="option.value"
                            v-model="frmData.content_type" :value="option.value" :aria-describedby="ariaDescribedby"
                            name="flavour-4a" inline>
                            <span :class="option.icon" />
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Loại hình xuất bản </label>
                          </template>
                          <v-select v-model="frmData.category_type_id" multiple class="maincats" label="title"
                            :options="dataCategoryType" :reduce="(val) => val.id" placeholder="--Chọn--" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group class="pt10">
                          <template #label>
                            <label class="d-block font-weight-bolder">&nbsp;</label>
                          </template>
                          <b-form-checkbox v-model="frmData.internal" value="1"> Tin nội bộ </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <validation-provider #default="validationContext" name="Nội dung" rules="required">
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Nội dung <span
                                  class="text-danger">*</span></label>
                            </template>
                            <editor ref="tinymce" v-model="frmData.content" :init="tinyOptions"
                              :state="getValidationState(validationContext)" tinymce-script-src="" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{
                              validationContext.errors[0] }} </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Tag" label-for="v-handler">
                          <voerro-tags-input v-model="tags" element-id="tags" :typeahead-url="api_tags" text-field="name"
                            :typeahead-hide-discard="true" placeholder="Nhập các thẻ mới được phân tách và bấm enter"
                            id-field="id" :typeahead="true" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group>
                          <!-- ATTACH ORIGINAL FILE -->
                          <article-original-file :attached-files="frmData.attached_files"
                            @update-attached-files="onUpdateAttachedFiles" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group>
                          <label for="textarea-default">Tin bài liên quan <b-badge v-b-modal.showRelate
                              class="relate_id ml-1" variant="blue">Thêm bài viết liên quan</b-badge></label>
                          <ul id="relate_news" class="control-multiple-checkbox list_relate_news mt-1">
                            <draggable v-model="frmData.relate_data" draggable=".item" group="people"
                              @start="dragging = true" @end="dragging = false">
                              <li v-for="(item, index) in frmData.relate_data" :key="index" class="item">
                                <a href="javascript:void(0)">{{ item.title }} </a>
                                <span class="icon_delete btn-delete" @click="handlRemoveRelate(item)" />
                              </li>
                            </draggable>
                          </ul>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Ghi chú">
                          <b-form-input v-model="frmData.note" placeholder="Ghi chú" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
              <!-- SIDEBAR -->
              <article-sidebar-right ref="refArticleSidebarRight" :frm-data="frmData" :top-class="topClass"
                :class="allow_show_published ? 'show-publish' : ''" @update-dalet="logDalet"
                @update-content-editor="UpdateContentEditor" @preview="onPreviewFile"
                @delete-file-content="onDeleteFileContent" @update-content-files="onUpdateContentFile"
                @show-transcribe-modal="showTranscribeModal" @hide-transcribe-modal="hideTranscribeModal">
                <div v-if="allow_show_published" class="form-publish p-1">
                  <b-form-group>
                    <b-form-checkbox v-model="frmData.is_timer" class="checkboxLabel" value="1"> Hẹn giờ xuất bản
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <flat-pickr v-model="frmData.published_at" class="form-control" :disabled="!frmData.is_timer"
                      :config="config_date" placeholder="hh:mm, dd-mm-yyyy" />
                  </b-form-group>
                </div>
              </article-sidebar-right>
            </div>
            <div class="cardsticky" style="z-index:9">

              <div class="divSave justify-content-center">
                <div class="btnLeft">
                  <b-button type="button" class="mr-1 text-uppercase" variant="exit" @click="onExit()">Thoát</b-button>
                </div>
                <div class="btnRight">
                  <b-button type="submit" variant="save" class="mr-1" @click="validationForm(frmData.status)">Lưu
                  </b-button>
                  <b-button v-for="(item, index) in workflowTransition" :key="index" type="button"
                    :variant="item.style ? item.style : 'btn_blue'" class="mr-1"
                    @click="validationForm(item.target_state)">
                    {{ item.desc }} </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </validation-observer>
    </b-overlay>
    <!-- MODAL RELATE POSTS -->
    <b-modal id="showRelate" body-class="p-0 mb-2" size="lg" cancel-variant="outline-secondary" no-close-on-backdrop
      hide-footer title="Danh sách bài viết">
      <dialog-relate :relate_ids="frmData.relate_data" @updateRelate="handleRelate" />
    </b-modal>
    <!-- MODAL TRANSCRIBE SPEECH TO TEXT -->
    <b-modal id="fileTranscribeModal" ref="refFileTranscribeModal" body-class="p-0" size="xlg"
      cancel-variant="outline-secondary" no-close-on-backdrop hide-footer centered modal-class="no-header"
      ignore-enforce-focus-selector=".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root" @shown="focusAudioPlayer"
      @hide="closeSocketSpeech">
      <template #modal-header="{ close }">
        <button type="button" aria-label="Close" class="close ml-auto px-1" @click="close"> × </button>
      </template>
      <FileTranscribeText ref="refFileTranscribeText" :file-data="fileData"
        :is-disconnect-socket="isDisconnectSocketSpeech" @hide-transcribe-modal="hideTranscribeModal"
        @update-transcribe-status="updateTranscribeStatus" @update-speech-to-text="handleSpeechToText"
        @update-icon="updateIcon" />
    </b-modal>
    <!-- MODAL FILE PREVIEW -->
    <b-modal id="filePreview" body-class="p-0 mb-2" size="xlg" cancel-variant="outline-secondary" no-close-on-backdrop
      hide-footer title="Xem">
      <file-preview :data-image="dataImage" @update-speech-to-text="handleSpeechToText" />
    </b-modal>
    <!-- MODAL FILE MANAGER -->
    <b-modal id="modal-file-manager" v-model="showFileManagerModal" :title="fileManagerTitle" size="xl" :ok-only="true"
      ok-title="Đóng" hide-footer scrollable>
      <file-manager :in-editor="true" @update-speech-to-text="handleSpeechToText" />
    </b-modal>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import _ from 'lodash';
import {
  BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback,
  BOverlay, BFormCheckbox, BFormGroup, BBadge, BModal,
} from 'bootstrap-vue'
import {
  ref, computed, reactive, toRefs,
} from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import draggable from 'vuedraggable'
import VoerroTagsInput from '@voerro/vue-tagsinput';
import {
  required, email, alphaNum, min, max,
} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import { dynamicImageSettingSrcByDomain, showToast } from '@core/utils/utils';
import axios from '@axios';
import { getToken } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt';
import {
  defaultOptions, apiUpload, apiDownload, insertFileToEditor,
} from '@/libs/initTinymce'
import DialogRelate from './DialogRelate.vue';
import filePreview from './FilePreview.vue'
import ArticleSidebarRight from './components/ArticleSidebarRight.vue'
import ArticleOriginalFile from './components/ArticleOriginalFile.vue'
import FileTranscribeText from './components/FileTranscribeText.vue'
import FileManager from '../files/FileManager.vue';
import '@voerro/vue-tagsinput/dist/style.css'
import useArticle from './useArticle';
import { io } from 'socket.io-client';

export default {
  components: {
    ArticleSidebarRight,
    ArticleOriginalFile,
    FileTranscribeText,
    BOverlay,
    BCol,
    BRow,
    BButton,
    BFormGroup,
    BForm,
    BFormInput,
    BFormCheckbox,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    AppBreadcrumb,
    vSelect,
    Editor,
    BBadge,
    DialogRelate,
    BModal,
    draggable,
    filePreview,
    FileManager,
    VoerroTagsInput,
    flatPickr,
  },
  data() {
    return {
      required,
      email,
      alphaNum,
      min,
      max,
      topClass: '',
      dataImage: {},
      fileData: {},
      tabActive: 'audio',
      isDisconnectSocketSpeech: false,
      socketSpeech: null,
    }
  },
  computed: {
    fileManagerTitle() {
      return this.$store.state.files.file_manager.title;
    },
    showFileManagerModal: {
      get() {
        // console.log('show_file_manager', this.$store.state.files.show_file_manager);
        return this.$store.state.files.show_file_manager;
      },
      set(val) {
        this.$store.dispatch('files/setState', { show_file_manager: val });
      },
    },
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true);

    this.initSocket();
  },
  beforeRouteLeave(to, from, next) {
    if (this.user_create) {
      this.$swal({
        text: 'Bạn có chắc chắn muốn rời khỏi màn hình tạo mới tin bài không?',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          if (this.socketSpeech) {
            this.socketSpeech.disconnect();
          }
          next();
        } else {
          next(false);
        }
      })
    } else {
      if (this.socketSpeech) {
        this.socketSpeech.disconnect();
      }
      next();
    }
  },
  setup(props, context) {
    // const { route, router } = useRouter();
    const dataUser = useJwt.getUserLocal();
    const pseudonym_alias = (dataUser) ? dataUser.alias_position_department : 'Root';
    const api_tags = `${process.env.VUE_APP_NEWS_API_URL}tags/search?search=:search`
    const tags = ref([])
    const state = reactive({
      tinyOptions: null,
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    state.tinyOptions = computed(() => {
      if (store.state.app.settings) {
        if (store.state.app.settings.news !== undefined && store.state.app.settings.news.editor_toolbar !== undefined) {
          const icons = store.state.app.settings.news.editor_toolbar.map(({ icon }) => icon);
          defaultOptions.toolbar = icons.join(' ');
        }
        if (store.state.app.settings.app !== undefined && store.state.app.settings.app.logo_mask !== undefined) {
          defaultOptions.images_mask_logo = dynamicImageSettingSrcByDomain(store.state.app.settings.app.logo_mask);
          // defaultOptions.images_mask_logo = 'https://auth.tintucvov.vn:1236/upload/setting/e97f6caa278662da90be88a4e6299d5c.31052023.png';
        }
      }
      return defaultOptions
    });
    // console.log('state.tinyOptions', state.tinyOptions);
    const defaultItemData = {
      id: '',
      title: '',
      article_type_id: '',
      content_type: ['news'],
      category_id: '',
      main_cats: [],
      image: '',
      featured: false,
      hot: false,
      dalet: 1,
      author: [],
      note: '',
      tags: [],
      attached_files: [],
      category_type_id: [],
      department_id: '',
      content_files: [],
      content: (pseudonym_alias) ? `<p>&nbsp;</p><p>&nbsp;</p><p class="text-align-right" style="text-align: right;"><strong><em>${pseudonym_alias}</em></strong></p>` : '',
      pseudonym: '',
      relate_data: [],
      user_author: [],
      published_at: '',
      status: 1,
      is_timer: 0,
      internal: '',
    }
    const frmData = ref(JSON.parse(JSON.stringify(defaultItemData)))
    const resetItemData = () => {
      frmData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const relateData = ref([]);
    const accessToken = getToken();
    const dataArticleType = ref([]);
    const dataContentType = ref([]);
    const files_content = ref([]);
    const dataAuthor = ref([]);
    const dataDepartment = ref([]);
    const dataTag = ref([]);
    const workflowTransition = ref([]);
    const all_cats = ref([]);
    const data_cats = ref([]);
    const attached_files = ref([])
    const loading = ref(false)
    const dataCategoryType = ref([])
    const allow_show_published = ref(false)
    const user_create = ref(true)
    const show_nhoxuly = ref(true);
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });

    const fetchConfig = () => {
      loading.value = true
      store.dispatch('article/config', { state: 1 })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            loading.value = false
            dataDepartment.value = result.data.department;
            frmData.value.department_id = result.data.department_id;
            if (result.data.articleType !== undefined) {
              dataArticleType.value = Array.isArray(result.data.articleType) ? result.data.articleType : [];
            }
            if (result.data.contentType !== undefined) {
              dataContentType.value = Array.isArray(result.data.contentType) ? result.data.contentType : [];
            }
            if (result.data.workflow_transition !== undefined) {
              workflowTransition.value = result.data.workflow_transition
              result.data.workflow_transition.forEach((itemVal) => {
                if (itemVal.target_state == 2) {
                  show_nhoxuly.value = false
                }
              })
            }

            dataCategoryType.value = result.data.categoryType
            data_cats.value = result.data.data_cats;
            all_cats.value = result.data.all_cats;
            allow_show_published.value = result.data.allow_show_published
          }
        })
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    const { openFileManager } = useArticle();

    // loading config
    fetchConfig();

    const config_date = ref({
      dateFormat: 'H:i, d-m-Y',
      wrap: true,
      enableTime: true,
      time_24hr: true,
      defaultHour: new Date().getHours(),
      defaultMinute: new Date().getMinutes(),
      locale: Vietnamese, // locale for this instance only
    });
    return {
      ...toRefs(state),
      refFormObserver,
      getValidationState,
      resetForm,
      frmData,
      dataArticleType,
      dataContentType,
      files_content,
      dataAuthor,
      custom_header,
      dataDepartment,
      dataTag,
      resetItemData,
      workflowTransition,
      dataUser,
      relateData,
      all_cats,
      attached_files,
      data_cats,
      loading,
      api_tags,
      tags,
      dataCategoryType,
      openFileManager,
      allow_show_published,
      config_date,
      user_create,
      show_nhoxuly,
    }
  },
  methods: {
    onExit() {
      this.$router.push({ name: 'article-private' });
    },
    logDalet(val) {
      //console.log('val', val)
    },
    selectedOption(option) {
      if (this.frmData.user_author.length > 0) {
        const isCheck = this.frmData.user_author.filter((val) => val.id == option.id);
        if (isCheck.length == 0) {
          this.frmData.user_author.push(option)
        }
      } else {
        this.frmData.user_author.push(option)
      }
    },
    deselectedOption(option) {
      if (this.frmData.user_author.length > 0) {
        const dataUserAuthor = this.frmData.user_author.filter((val) => val.id != option.id);
        this.frmData.user_author = dataUserAuthor;
      }
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    handleScroll(e) {
      if (window.pageYOffset > 20) {
        this.topClass = 'top_class';
      } else {
        this.topClass = '';
      }
    },
    search: _.debounce((loading, search, vm) => {
      axios.get(`users/search?keyword=${search}`)
        .then((response) => {
          if (vm.dataAuthor.length < 1 && response.data.data.length > 0) {
            vm.dataAuthor = response.data.data;
          } else {
            const dataNews = [];
            vm.dataAuthor.map((item) => {
              if (vm.frmData.author.includes(item.id)) {
                dataNews.push(item);
              }
            })
            if (response.data.data.length > 0) {
              response.data.data.map((item) => {
                if (!vm.frmData.author.includes(item.id)) {
                  dataNews.push(item);
                }
              })
            }
            const sortedObjs = _.sortBy(dataNews, 'full_name');
            vm.dataAuthor = sortedObjs
          }
          loading(false);
        })
    }, 500),
    validationForm(state) {
      this.frmData.status = state;
      if (this.tags.length > 0) {
        this.frmData.tags = this.tags.map(tagItem => tagItem.name);
      }
      if (state == 2 && !this.frmData.department_id) {
        showToast('Chưa chọn phòng nhờ xử lý');
        this.$refs.department_id.$el.focus();
      } else {
        this.$refs.articleForm.validate()
          .then(success => {
            if (success) {
              this.onSubmit();
            } else {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
          })
      }
    },
    onSubmit() {
      this.loading = true
      const newContentFiles = [];
      if (this.frmData.content_files.length) {
        this.frmData.content_files.forEach(item => {
          const newitem = { ...item };
          delete newitem.file;
          delete newitem.headers;
          delete newitem.uploader;
          newContentFiles.push(newitem)
        });
      }
      this.user_create = false
      this.frmData.content_files = newContentFiles;
      store.dispatch('article/create', this.frmData)
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            this.loading = false
            showToast(result.message, { variant: 'success' });
            // showToast(result.message, { variant: 'success' });
            const { data } = result;
            // if (data.status == 1) {
            //   this.$router.push({ name: 'article-edit', params: { id: data.id } });
            // } else {
            this.$router.push({ name: 'article-private' });
            // }
          } else if (result.errors) {
            this.$refs.articleForm.setErrors(result.errors);
          }
        })
    },
    updateIcon(item) {
      if (item.type === 'image' || item.isImage) {
        if (!this.frmData.content_type.includes('photo')) {
          this.frmData.content_type.push('photo')
        }
      } else if (item.type === 'video' || item.isVideo) {
        if (!this.frmData.content_type.includes('video')) {
          this.frmData.content_type.push('video')
        }
      } else if (item.type === 'audio' || item.isAudio) {
        if (!this.frmData.content_type.includes('audio')) {
          this.frmData.content_type.push('audio')
        }
      }

    },
    UpdateContentEditor(item) {
      //console.log('UpdateContentEditor', item);
      const data = item.response != undefined ? item.response : item;
      if (typeof data.name !== undefined) {
        const res = (item.response !== undefined) ? item.response.data : item;
        res.full_path = res.full_path || res.file_local;
        // console.log('res.name', res.name);
        insertFileToEditor(res);
        this.updateIcon(res)
        // hide transcrible modal
        this.hideTranscribeModal();
      }
    },

    handlRemoveRelate(item) {
      const relateData = this.frmData.relate_data.filter((val) => val.id !== item.id);
      this.frmData.relate_data = relateData;
    },
    handleRelate(data) {
      const itemActive = this.frmData.relate_data.filter((val) => val.id === data.id);
      if (itemActive.length > 0) {
        const relateData = this.frmData.relate_data.filter((val) => val.id !== data.id);
        this.frmData.relate_data = relateData;
      } else {
        this.frmData.relate_data.push(data);
      }
    },
    onUpdateAttachedFiles(attachedFiles) {
      this.frmData.attached_files = attachedFiles
    },
    onUpdateContentFile(files) {
      this.frmData.content_files = files;
    },
    onDeleteFileContent(file) {
      if (this.frmData.content_files.length > 0) {
        const content_files = this.frmData.content_files.filter((item) => item.id != file.id)
        this.frmData.content_files = content_files;
      }
    },
    onPreviewFile(item) {
      this.dataImage = item
      //console.log('dataImage', this.dataImage);
      this.$bvModal.show('filePreview');
    },

    handleSpeechToText(content) {
      // console.log('hanld text to speech', content)
      // console.log('tinymce', tinymce)
      tinymce.activeEditor.insertContent(content);
    },

    showTranscribeModal(item) {
      this.fileData = item;
      this.$bvModal.show('fileTranscribeModal');
    },
    hideTranscribeModal() {
      //console.log('hideTranscribeModal');
      this.$bvModal.hide('fileTranscribeModal');
    },
    focusAudioPlayer() {
      // console.log('this.$refs.refFileTranscribeText', this.$refs.refFileTranscribeText);
      // this.$refs.refFileTranscribeText.$refs.refTinymceSpeech.editor.focus()
      // console.log('this.$refs.refFileTranscribeModal', this.$refs.refFileTranscribeModal);
      // this.$refs.refFileTranscribeText.$refs.refAudioWrapper.focus()
      // this.$refs.refFileTranscribeModal.$el.style.zIndex = 1020
    },
    updateTranscribeStatus(data) {
      // console.log('edit article updateTranscribeStatus', data);
      this.fileData.transcribe = data.transcribe
      if (this.frmData.content_files) {
        this.frmData.content_files.find((o, idx) => {
          if (o.id === data.id) {
            o.transcribe = data.transcribe
            this.$set(this.frmData.content_files, idx, o)
          }
        });
      }
    },
    closeSocketSpeech() {
      this.$store.dispatch('speech/setState', { isDisconnectSocket: (new Date()).getTime() })
    },
    initSocket() {
      const that = this;
      const socketUrl = process.env.VUE_APP_SPEECH_SOCKET || 'http://localhost:3006';
      const socketPath = process.env.VUE_APP_SPEECH_SOCKET_PATH || '/socket.io/';
      const socket = io(socketUrl, {
        path: socketPath,
        transports: ['websocket'],
      });
      // console.log('socketUrl', socketUrl);
      // console.log('socketPath', socketPath);
      this.socketSpeech = socket;

      socket.on('connect', () => {
        //console.log('initSocket on connect');
        this.socketId = socket.id;
      });

      socket.on('file-transcribed', (data) => {
        //console.log('socket on file-transcribed data', data);
        //console.log('this.frmData.content_files', this.frmData.content_files);
        if (this.fileData.id === data.id) {
          this.fileData.transcribe = data.transcribe
        }
        if (this.frmData.content_files) {
          this.frmData.content_files.find((o, idx) => {
            if (o.id === data.id) {
              showToast(`Rải băng ${o.filename_original} thành công`, { variant: 'success' });
              o.transcribe = data.transcribe
              this.$set(this.frmData.content_files, idx, o)
            }
          });
        }
      });
      socket.on('test-send-message', () => {
        showToast('test send message');
      });
      socket.on('disconnect', () => {
        //console.log('initSocket on disconnect');
      });
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.articleForm {
  .maincats {
    /* Selected */
    --vs-dropdown-option--active-bg: #5897fb;
    --vs-dropdown-option--active-color: #fff;
  }

  .checkitem1 {
    margin-top: 3rem !important;
  }

  .attached_files img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
  }

  .d-center {
    display: flex;
    align-items: center;
  }

  .selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
  }

  .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active>a {
    color: #fff;
  }

}
</style>
